import UltMeta, { Meta } from "@/meta/UltMeta/index";

class CustomerAdvancePaymentState extends UltMeta {
    SUCCESS = new Meta(1, "成功", "success-state");
    REVOKE = new Meta(2, "已撤销", "revoke-state");
}

export const CUSTOMER_ADVANCE_PAY_STATE = new CustomerAdvancePaymentState();
